import 'jquery-ui-dist/jquery-ui.min.js'
import '@fancyapps/fancybox';
import 'jquery-ui-touch-punch/jquery.ui.touch-punch';

const foodCheck = {};

(function (foodCheckApp) {

    const pages = {
        ageSelection : "ageSelection",
        healthOptions: "healthOptions",
        proteinPreferences: "proteinPreferences",
        results: "results"
    };

    let currentPage = pages.ageSelection;
    let bhFoodCheckSelector = {
        name: "",
        year: 0,
        month: 0,
        weight: 5,
        healthOption: 0,
        wetProteinPreference: 0,
        dryProteinPreference: 0
    };

    $(document).ready(function () {
        const footer = $(".footer");
        const breadcrumbs = $(".breadcrumbs");
        $("[data-fancybox]").fancybox();
        footer.hide();
        breadcrumbs.hide();

        function reInitializeAgeSelectionPage() {
            $("#pet-name").val(bhFoodCheckSelector.name);
            $("#pet-year").val(bhFoodCheckSelector.year);
            $("#pet-month").val(bhFoodCheckSelector.month);
        }

        function getResultsPage() {
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetCatsResultsPage",
                type: "GET",
                data: { ...bhFoodCheckSelector, documentId: $("#documentId").val(), animalType: "Cat" },
                dataType: "html",
                success: function (data) {
                    $(".quiz").hide();
                    $(".js-quiz-results-render").show();
                    $(".js-quiz-results-render").html(data);
                    changeQuizBottomPanel(pages.results);
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });
        }

        function getAgeSelectionPage() {
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetAgeSelection",
                type: "GET",
                data: {
                    BhFoodCheckSelectorId: $("#documentId").val(),
                    AnimalType: 'Cat'
                },
                dataType: "html",
                success: function (data) {
                    $(".selected-form").html(data);
                    changeQuizBottomPanel(pages.ageSelection);
                    reInitializeAgeSelectionPage();
                    formIsValid();
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });
        }
        function getProteinPreferencesPage() {
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetProteinPreferencesOptions",
                type: "GET",
                data: {
                    Name: bhFoodCheckSelector.name,
                    FoodCheckSelectorId: $("#documentId").val(),
                    Year: bhFoodCheckSelector.year,
                    Month: bhFoodCheckSelector.month,
                    Weight: bhFoodCheckSelector.weight,
                    HealthOptionId: bhFoodCheckSelector.healthOption,
                    AnimalType: 'Cat'
                },
                dataType: "html",
                success: function (data) {
                    if (!data.includes('quiz-results-header')) {
                        $(".js-quiz-results-render").hide();
                        $(".quiz").show();
                        $(".selected-form").html(data);
                        changeQuizBottomPanel(pages.proteinPreferences);
                        initializeProteinPreferencesPage();
                    } else {
                        $(".quiz").hide();
                        $(".js-quiz-results-render").show();
                        $(".js-quiz-results-render").html(data);
                        changeQuizBottomPanel("results");
                    }
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });

        }

        function getHealthOptionsPage(isBack = false) {
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetHealthOptionsSelection",
                type: "GET",
                data: {
                    Name: bhFoodCheckSelector.name,
                    FoodCheckSelectorId: $("#documentId").val(),
                    Year: bhFoodCheckSelector.year,
                    Month: bhFoodCheckSelector.month,
                    Weight: bhFoodCheckSelector.weight,
                    AnimalType: 'Cat'
                },
                dataType: "html",
                success: function (data) {
                    if (!data.includes('protein-preferences-section')) {
                        $(".selected-form").html(data);
                        changeQuizBottomPanel(pages.healthOptions);
                        initializeHealthOptionsPage();
                    } else {
                        if (isBack) {
                            getAgeSelectionPage()
                        } else {
                            $(".selected-form").html(data);
                            changeQuizBottomPanel(pages.proteinPreferences);
                            initializeProteinPreferencesPage();
                        }
                    }
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });
        }

        function initializeBreadCrumbs() {
            $(`.${currentPage}`).addClass('is-active');
        }

        function initializeHealthOptionsPage() {
            if (bhFoodCheckSelector.healthOption !== 0) {
                $(`#${bhFoodCheckSelector.healthOption}`).closest('.quiz-question').addClass('is-complete');
            }
        }

        function initializeProteinPreferencesPage() {
            if (bhFoodCheckSelector.dryProteinPreference !== 0 && bhFoodCheckSelector.wetProteinPreference !== 0) {
                $(`#${bhFoodCheckSelector.dryProteinPreference}`).closest('.quiz-question').addClass('is-complete');
                $(`#${bhFoodCheckSelector.wetProteinPreference}`).closest('.quiz-question').addClass('is-complete');
            }
            $("#get-results").attr("disabled", "disabled");
        }

        $(document).on("click", '.quiz-question__link', function () {
            const allQuizQuestions = $(".quiz-question");

            if (currentPage !== pages.proteinPreferences) {
                allQuizQuestions.each(function () {
                    $(this).removeClass('is-complete')
                });
            }
            else {
                var foodType = getFoodType($(this))
                allQuizQuestions.toArray().forEach(function (element) {
                    let hasClass = $(element).closest('.quiz-question').find('.quiz-question__link').hasClass(foodType);
                    if (hasClass) {
                        $(element).removeClass('is-complete');
                    }
                });
            }

            //add class
            $(this).closest('.quiz-question').addClass('is-complete');

            switch (currentPage) {
                case pages.healthOptions:
                    bhFoodCheckSelector.healthOption = +$(this).closest('.quiz-question').find('.quiz-question__link').attr('id');
                    break;
                case pages.proteinPreferences:
                    const proteinSelections = getProteinSelections();
                    bhFoodCheckSelector.dryProteinPreference = proteinSelections.dry;
                    bhFoodCheckSelector.wetProteinPreference = proteinSelections.wet;

                    if (bhFoodCheckSelector.dryProteinPreference !== 0 && bhFoodCheckSelector.wetProteinPreference !== 0)
                        $('#get-results').removeAttr("disabled");
                    break;
            }
        });

        function getFoodType(element) {
            if ($(element).hasClass('wet'))
                return 'wet';

            if ($(element).hasClass('dry'))
                return 'dry';

            return 'no-food-type';
        }

        function getProteinSelections() {
            let selectedElements = $(document).find('.is-complete');

            if (selectedElements.length !== 2)
                return { 'dry': 0, 'wet': 0 };

            var object = {};
            selectedElements.toArray().forEach(function (element) {
                let questionLink = $(element).closest('.quiz-question').find('.quiz-question__link');
                object[getFoodType(questionLink)] = $(questionLink).attr('id');
            });

            return object;
        }

        function changeQuizBottomPanel(selectedPage){
            currentPage = selectedPage;
            const bottomPanel = $(".quiz__bottom-panel");
            const quizProgress = $(".quiz-progress");
            const quizBottomPanelGetResult = $(".quiz__bottom-panel-results");

            switch(currentPage){
                case pages.ageSelection:
                    bottomPanel.hide();
                    quizProgress.hide();
                    footer.hide();
                    breadcrumbs.hide();
                    quizBottomPanelGetResult?.hide();
                    break;
                case pages.healthOptions:
                    bottomPanel.show();
                    quizProgress.show();
                    footer.hide();
                    breadcrumbs.hide();
                    quizBottomPanelGetResult?.hide();
                    break;
                case pages.proteinPreferences:
                    bottomPanel.hide();
                    quizProgress.show()
                    footer.hide();
                    breadcrumbs.hide();
                    quizBottomPanelGetResult?.show();
                    break;
                case pages.results:
                    bottomPanel.hide();
                    quizProgress.hide()
                    quizBottomPanelGetResult?.show();
                    footer.show();
                    breadcrumbs.show();
                    break;
            }

            const healthOptionNextHandler = function() {
                $('#next-button').removeAttr("disabled");
            };
            if(currentPage === pages.healthOptions)
            {
                $(".js-health-option--link").on("click", healthOptionNextHandler);
                $('#next-button').attr("disabled", "disabled");
            }else{
                $('#next-button').removeAttr("disabled");
                $(".js-health-option--link").off("click", healthOptionNextHandler);
            }

            initializeBreadCrumbs();
        }

        function formIsValid(){
            const submitBtn = $("#age-selection-submit");
            bhFoodCheckSelector.name = $('#pet-name').val();
            bhFoodCheckSelector.year = +$('#pet-year').val();
            bhFoodCheckSelector.month = +$('#pet-month').val();

            if(bhFoodCheckSelector.name === '' || (bhFoodCheckSelector.year === 0 && bhFoodCheckSelector.month === 0))
            {
                submitBtn.prop("disabled", true);
                return false;
            }

            submitBtn.prop("disabled", false);
            return true;
        }

        function scrollToTop() {
            $('html, body').animate({
                scrollTop: $("main").offset().top
            }, 400);
        }

        $(document).on("change", ".pet-age-form", function (e) {
            e.preventDefault();
            formIsValid();
        });

        $(document).on("click", "#js-previous-button", function(e) {

            e.preventDefault();

            switch(currentPage){
                case pages.healthOptions:
                    getAgeSelectionPage();
                    break;
                case pages.proteinPreferences:
                    getHealthOptionsPage(true);
                    break;
                case pages.results:
                    getProteinPreferencesPage();
                    break;
            }

            $(`.${currentPage}`).removeClass('is-active');

            scrollToTop();
        });

        $(document).on("click", "#next-button", function(e) {
            e.preventDefault();

            switch(currentPage){
                case pages.ageSelection:
                    getHealthOptionsPage();
                    break;
                case pages.healthOptions:
                    getProteinPreferencesPage();
                    break;
            }

            scrollToTop();
        });

        $(document).on("click", "#js-start-over-button", function(e){
            e.preventDefault();
            window.location.reload();
        });

        $(document).on("click", "#get-results", function(e) {
            e.preventDefault();

            if (!document.getElementById('get-results').hasAttribute('disabled'))
                getResultsPage();

            scrollToTop();
        });

        $(document).on("click", "#age-selection-submit", function (e) {
            e.preventDefault();

            if (formIsValid())
            {
                getHealthOptionsPage();
            }
            scrollToTop();
        });
    });

})(foodCheck);
